import React from 'react';
import classNames from 'classnames';
export var EuiRangeWrapper = function EuiRangeWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      fullWidth = _ref.fullWidth,
      compressed = _ref.compressed;
  var classes = classNames('euiRangeWrapper', {
    'euiRangeWrapper--fullWidth': fullWidth,
    'euiRangeWrapper--compressed': compressed
  }, className);
  return React.createElement("div", {
    className: classes
  }, children);
};
EuiRangeWrapper.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EuiRangeWrapper",
  "props": {
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "fullWidth": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "compressed": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};